import $ from 'jquery';
import '../Language/parsley';
import 'parsleyjs';
import _ from '../Libraries/translations';

const isMobile = () => $(window).width() < 992;

// prevent click and submit the quick-bookin form instead
$('.meta-nav__link--booking, a.booking-bar').on('click', ev => {
    let $item = (isMobile()
            ? $('a.quick-booking__button')
            : $('.quick-booking__button[type="submit"]')
    );
    if ($item.length > 0) {
        ev.preventDefault();
        $item.trigger('click');
    }
});


// in mobile we have to append the current date + 1 for the start-tade and +3 for the end-date
// to the link, as it's not actually the form button that's visible.
$('a.quick-booking__button').on('click', ev => {
    if (!isMobile()) {
        return;
    }
    ev.preventDefault();
    let url = new URL(ev.currentTarget.href, window.location.href);
    let params = Array.from(url.searchParams)
        .reduce((acc, [a, b]) => Object.assign(acc, {[a]: b}), {});

    let ibeFrom = new Date;
    let ibeTo = new Date;
    ibeFrom.setDate(ibeFrom.getDate() + 1);
    ibeTo.setDate(ibeTo.getDate() + 3);

    params['ibe-from'] = isoDate(ibeFrom);
    params['ibe-to'] = isoDate(ibeTo);

    url.search = '?' + $.param(params);
    ev.currentTarget.href = url.href;

    let newLink = document.createElement('a');
    newLink.href = url.href;
    newLink.click();
});


const isoDate = (date) => {
    let offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString().split('T')[0];
}


// Main quick booking form submission logic. Parameters need special
// formats for the target pages scripts to work
$('.quick-booking__form, .search-overlay__booking-form').on('submit', function (ev) {
    ev.preventDefault();
    const $form = $(this);


    let ibeFrom = $form.find('input[name="ibe-from"]')[0]._airDatepickerInstance.lastSelectedDate;
    let ibeTo = $form.find('input[name="ibe-to"]')[0]._airDatepickerInstance.lastSelectedDate;

    if (ibeFrom === undefined && $form.find('input[name="ibe-from"]').val().length > 0) {
        ibeFrom = parseDate($form.find('input[name="ibe-from"]').val());
    }

    if (ibeTo === undefined && $form.find('input[name="ibe-to"]').val().length > 0) {
        ibeTo = parseDate($form.find('input[name="ibe-to"]').val());
    }

    let ibeAdults = Number($form.find('select[name="ibe-adults"]').val());
    let ibeChildren = Number($form.find('select[name="ibe-children"]').val());
    let ibeBookType = $form.find('select[name="ibe-book-type"]').val();

    if (isNaN(ibeAdults)) {
        ibeAdults = 0;
    }

    if (isNaN(ibeChildren)) {
        ibeChildren = 0;
    }

    let occupancyData = {
        "adults": ibeAdults,
        "children": [],
        "children_ages": [],
    }

    let baseUrl = $form.attr('action');
    let params = {
        'ibe-occupation': ibeAdults + ibeChildren,
        'ibe-occupationList': ibeAdults + ibeChildren,
        'ibe-only-additional-rooms': 1,
        'page': 1,
        'ibe-view': 'list',
        'ibe-region': 'wea30cf9e0b4b66a5999',
    };

    if (ibeBookType.length > 0) {
        params['ibe-book_type[]'] = Number(ibeBookType);
    }

    if (ibeFrom !== undefined && ibeTo !== undefined) {
        params['ibe-from'] = isoDate(ibeFrom);
        params['ibe-to'] = isoDate(ibeTo);
    }

    function redirect(params, occupancyData) {
        var i = 0;
        if (occupancyData.adults === 0) {
            delete occupancyData.adults;
            i++;
        }

        if (occupancyData.children.length === 0) {
            delete occupancyData.children;
            delete occupancyData.children_ages;
            i++;
        }

        if (i === 2) {
            delete params['ibe-occupation'];
            delete params['ibe-occupationList'];
        } else {
            params['ibe-additional_occupancy_data'] = '[' + JSON.stringify(occupancyData) + ']';
        }

        let searchParams = new URLSearchParams(params);
        window.location = baseUrl + '?' + searchParams.toString();
    }

    if (!isNaN(ibeChildren) && ibeChildren !== 0) {
        let $html = $('<form class="children-age-selector"></form>');
        $html.append($('<h4></h4>').text(_('input-age-of-children')));

        let $child;
        for (let i = 0; i < ibeChildren; i++) {
            $child = $('<div class="form-group"></div>');
            $child.append($('<label class="control-label">' + _('nth-child', (i + 1)) + '</label>'));
            $child.append($('<input name="children_ages[' + i + ']" class="form-control" required="required" max="20">'));
            $html.append($child);
        }

        let $ok = $('<button class="button button--primary">' + _('ok') + '</button>');
        let $cancel = $('<button class="button button--outline-primary">' + _('cancel') + '</button>');

        let $wrap = $('<div class="text-right"></div>');
        $wrap.append($cancel);
        $wrap.append($ok);
        $html.append($wrap);

        $.magnificPopup.open({
            items: {
                type: 'inline',
                src: $html
            }
        });

        $cancel.on('click', function (ev) {
            ev.preventDefault();
            $.magnificPopup.close();
            // do nothing.
        });

        $ok.on('click', function (ev) {
            ev.preventDefault();
            let mfp = $.magnificPopup.instance;
            let $inputs = $('input[name^="children"]', mfp.content);
            let $childForm = $(this).closest('form');
            $childForm.closest('form').parsley().validate();

            let childrenValues = [];

            if ($childForm.parsley().isValid()) {
                $inputs.each(function (i, item) {
                    let $input = $(item);
                    childrenValues.push($input.val())
                });
                occupancyData['children_ages'] = childrenValues;
                occupancyData['children'] = childrenValues;

                $.magnificPopup.close();
                redirect(params, occupancyData);
            }
        });

        return false;
    }

    redirect(params, occupancyData);
});

function parseDate(dateString) {
    var dateParts = dateString.split(".");
    return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
}
